module.exports = require("webpack");


//////////////////
// WEBPACK FOOTER
// external "webpack"
// module id = 13
// module chunks = 0